module.exports = __webpack_public_path__ + "img/work3.fd43d425.png";